const SALT = 'rp_sec_2026_@v9!';

function generateToken(time) {
  const str = `${SALT}_${time}_restpocket`;
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
  }
  return (hash >>> 0).toString(16);
}

function decodePayload(encodedStr, time) {
  try {
    const binaryStr = atob(encodedStr);
    const keyStr = `k_${time % 997}_rp`;
    const encoder = new TextEncoder();
    const keyBytes = encoder.encode(keyStr);

    const bytes = new Uint8Array(binaryStr.length);
    for (let i = 0; i < binaryStr.length; i++) {
      bytes[i] = binaryStr.charCodeAt(i) ^ keyBytes[i % keyBytes.length];
    }

    const decodedText = new TextDecoder('utf-8').decode(bytes);
    return JSON.parse(decodedText);
  } catch (e) {
    console.error('Failed to decode secure payload:', e);
    return [];
  }
}

/**
 * Secure fetch wrapper for RestPocket Netlify Functions
 */
export async function secureFetch(url, options = {}) {
  const now = Date.now();
  const token = generateToken(now);

  const headers = {
    'Content-Type': 'application/json',
    'x-app-client': 'restpocket-web',
    'x-app-time': now.toString(),
    'x-app-token': token,
    ...(options.headers || {})
  };

  const response = await fetch(url, {
    ...options,
    headers
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const result = await response.json();

  // If response has obfuscated payload
  if (result && result.payload && result._sec) {
    return decodePayload(result.payload, result._sec);
  }

  // Otherwise return standard json
  return result;
}
